import { addChildrenCampaignsToParentGroupCampaign as addChildrenCampaignsToParentGroupCampaignUtil } from '../utils/addChildrenCampaignsToParentGroupCampaign';
import { removeChildrenCampaignsFromParentGroupCampaign as removeChildrenCampaignsFromParentGroupCampaignUtil } from '../utils/removeChildrenCampaignsFromParentGroupCampaign';
import { updateCampaignGroupParent } from '../utils/updateCampaignGroupParent';
import { hasCampaignInReview } from '../utils/hasCampaignInReview';
import { CampaignListItem } from 'modules/campaigns/types/CampaignListItem';

type Params = {
  campaignsList: CampaignListItem[];
  setCampaigns: React.Dispatch<React.SetStateAction<any[]>>;
};

export const useCampaignsGroupHandler = ({
  campaignsList,
  setCampaigns
}: Params) => {
  const addChildrenCampaignsToParentGroupCampaign = ({
    childrenCampaigns,
    campaignGroupId,
    isParentInOtherCampaigns
  }: {
    childrenCampaigns: CampaignListItem[];
    campaignGroupId: string;
    isParentInOtherCampaigns: boolean | undefined;
  }) => {
    const updatedCampaigns = addChildrenCampaignsToParentGroupCampaignUtil({
      childrenCampaigns,
      campaignGroupId,
      campaigns: campaignsList,
      isParentInOtherCampaigns
    });

    const updatedCampaignsSetParentInReview = updateCampaignGroupParent({
      campaignGroupId,
      isNestedCampaignNeedsReview: false,
      isParentExpanded: true,
      campaigns: updatedCampaigns
    });

    setCampaigns([...updatedCampaignsSetParentInReview]);
  };

  const removeChildrenCampaignsFromParentGroupCampaign = ({
    campaignGroupId,
    childrenCampaigns
  }: {
    campaignGroupId: string;
    childrenCampaigns: CampaignListItem[];
  }) => {
    const updatedChildrenCampaigns =
      removeChildrenCampaignsFromParentGroupCampaignUtil({
        campaignGroupId,
        campaigns: campaignsList
      });

    const updatedCampaigns = updateCampaignGroupParent({
      campaignGroupId,
      isNestedCampaignNeedsReview: hasCampaignInReview({
        campaigns: childrenCampaigns
      }),
      isParentExpanded: false,
      campaigns: updatedChildrenCampaigns
    });

    setCampaigns(updatedCampaigns);
  };

  return {
    addChildrenCampaignsToParentGroupCampaign,
    removeChildrenCampaignsFromParentGroupCampaign
  };
};
